import { Tabs as TabsCore } from '@studiometa/ui';

/**
 * Tabs component
 */
export default class Tabs extends TabsCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Tabs',
    refs: ['btn[]', 'content[]'],
    options: {
      styles: {
        type: Object,
        default: () => ({
          btn: {
            open: {
              opacity: 1,
            },
          },
          content: {
            closed: {
              position: 'absolute',
              opacity: '0',
              pointerEvents: 'none',
              visibility: 'hidden',
            },
          },
        }),
        merge: true,
      },
    },
  };

  /**
   * Enable item
   * @param {TabItem} item The item to enable
   * @returns {Promise<this>}
   */
  async enableItem(item) {
    const { btn } = item;
    btn.setAttribute('aria-selected', 'true');
    return super.enableItem(item);
  }

  /**
   * Disable item
   * @param {TabItem} item The item to disable
   * @returns {Promise<this>}
   */
  async disableItem(item) {
    const { btn } = item;
    btn.setAttribute('aria-selected', 'false');
    return super.disableItem(item);
  }
}
